// src/app/auth.guard.ts

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AuthService } from './service/auth/auth.service';

@Injectable()
export class ApplicationGuard implements CanActivate {
  isApp: boolean;
  constructor(
    private router: Router,
    private authService: AuthService,
  ) {
    let userAgent = window.navigator.userAgent;
    this.isApp = userAgent.indexOf('hey_application') > -1
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.isApp) {
      if (this.authService.getToken()) {
        this.router.navigate(['/member', 'home']);
      } else {
        this.router.navigate(['/login']);
      }
      return false;
    } else {
      this.router.navigate(['/member', 'hey']);
      return false;
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/application.guard.ts